// PWA Installation Page
function initinstall() {
    const page = document.getElementById('page-install');
    
    // Detect platform
    const platform = detectPlatform();
    const isInstalled = isPWAInstalled();
    
    page.innerHTML = `
        <header class="p-4 flex items-center space-x-4 backdrop-blur-md z-20 shrink-0 shadow-md" style="background-color: var(--surface-current); border-bottom: 1px solid var(--border-current);">
            <button id="install-back-button" class="p-2 rounded-full hover:bg-opacity-20 transition-colors app-button-secondary">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                </svg>
            </button>
            <h1 class="text-xl font-semibold">Install Polyglot</h1>
        </header>

        <main class="flex-grow p-4 md:p-6 overflow-y-auto">
            <div class="max-w-2xl mx-auto">
                ${isInstalled ? createInstalledContent() : createInstallContent(platform)}
            </div>
        </main>
    `;

    // Set up event handlers
    setupInstallPageHandlers(platform, isInstalled);
}

function detectPlatform() {
    const userAgent = navigator.userAgent.toLowerCase();
    const platform = navigator.platform.toLowerCase();
    
    if (/iphone|ipad|ipod/.test(userAgent)) {
        return 'ios';
    } else if (/android/.test(userAgent)) {
        return 'android';
    } else if (/mac/.test(platform)) {
        return 'mac';
    } else if (/win/.test(platform)) {
        return 'windows';
    } else if (/linux/.test(platform)) {
        return 'linux';
    } else {
        return 'desktop';
    }
}

function isPWAInstalled() {
    // Check if running as PWA
    if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) {
        return true;
    }
    
    // Check if running in fullscreen mode (another PWA indicator)
    if (window.navigator.standalone === true) {
        return true;
    }
    
    // Check for PWA-specific properties
    if (document.referrer.includes('android-app://')) {
        return true;
    }
    
    return false;
}

function createInstalledContent() {
    return `
        <div class="text-center">
            <div class="inline-block p-6 mb-6 rounded-full" style="background-color: var(--accent-current);">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="w-12 h-12">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            </div>
            
            <h2 class="text-2xl font-bold mb-4" style="color: var(--text-current);">Polyglot is Installed!</h2>
            
            <p class="text-lg mb-6" style="color: var(--muted-text-current);">
                Great! You're already using Polyglot as an installed app. Enjoy the full offline experience and quick access from your device.
            </p>
            
            <div class="app-element p-6 rounded-lg">
                <h3 class="text-lg font-semibold mb-4" style="color: var(--text-current);">App Features</h3>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4 text-left">
                    <div class="flex items-start space-x-3">
                        <svg class="w-5 h-5 mt-0.5" style="color: var(--accent-current);" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                        </svg>
                        <div>
                            <p class="font-medium" style="color: var(--text-current);">Offline Support</p>
                            <p class="text-sm" style="color: var(--muted-text-current);">Works without internet for basic features</p>
                        </div>
                    </div>
                    <div class="flex items-start space-x-3">
                        <svg class="w-5 h-5 mt-0.5" style="color: var(--accent-current);" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                        </svg>
                        <div>
                            <p class="font-medium" style="color: var(--text-current);">Quick Access</p>
                            <p class="text-sm" style="color: var(--muted-text-current);">Launch from home screen or desktop</p>
                        </div>
                    </div>
                    <div class="flex items-start space-x-3">
                        <svg class="w-5 h-5 mt-0.5" style="color: var(--accent-current);" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                        </svg>
                        <div>
                            <p class="font-medium" style="color: var(--text-current);">Native Feel</p>
                            <p class="text-sm" style="color: var(--muted-text-current);">App-like experience with full-screen mode</p>
                        </div>
                    </div>
                    <div class="flex items-start space-x-3">
                        <svg class="w-5 h-5 mt-0.5" style="color: var(--accent-current);" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                        </svg>
                        <div>
                            <p class="font-medium" style="color: var(--text-current);">Fast Performance</p>
                            <p class="text-sm" style="color: var(--muted-text-current);">Optimized for speed and responsiveness</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
}

function createInstallContent(platform) {
    return `
        <div class="text-center mb-8">
            <h2 class="text-2xl font-bold mb-4" style="color: var(--text-current);">Install Polyglot</h2>
            
            <p class="text-lg mb-6" style="color: var(--muted-text-current);">
                Get the full app experience with offline support, quick access, and native performance.
            </p>
            
            <button id="install-pwa-button" class="app-button app-button-primary px-8 py-3 mb-6">
                <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
                </svg>
                Install Now
            </button>
        </div>
        
        <!-- Platform-specific instructions -->
        <div class="app-element p-6 rounded-lg mb-6">
            <h3 class="text-lg font-semibold mb-4" style="color: var(--text-current);">
                Installation Instructions for ${getPlatformDisplayName(platform)}
            </h3>
            ${getPlatformInstructions(platform)}
        </div>
    `;
}

function getPlatformDisplayName(platform) {
    const names = {
        'ios': 'iPhone/iPad',
        'android': 'Android',
        'mac': 'Mac',
        'windows': 'Windows',
        'linux': 'Linux',
        'desktop': 'Desktop'
    };
    return names[platform] || 'Your Device';
}

function getPlatformInstructions(platform) {
    switch (platform) {
        case 'ios':
            return `
                <div class="space-y-4">
                    <div class="flex items-start space-x-3">
                        <span class="flex-shrink-0 w-6 h-6 bg-blue-500 text-white text-xs font-bold rounded-full flex items-center justify-center">1</span>
                        <p class="text-sm" style="color: var(--text-current);">Tap the <strong>Share</strong> button in Safari (square with an arrow)</p>
                    </div>
                    <div class="flex items-start space-x-3">
                        <span class="flex-shrink-0 w-6 h-6 bg-blue-500 text-white text-xs font-bold rounded-full flex items-center justify-center">2</span>
                        <p class="text-sm" style="color: var(--text-current);">Scroll down and tap <strong>"Add to Home Screen"</strong></p>
                    </div>
                    <div class="flex items-start space-x-3">
                        <span class="flex-shrink-0 w-6 h-6 bg-blue-500 text-white text-xs font-bold rounded-full flex items-center justify-center">3</span>
                        <p class="text-sm" style="color: var(--text-current);">Tap <strong>"Add"</strong> to confirm</p>
                    </div>
                    <div class="mt-4 p-3 bg-blue-50 rounded-lg">
                        <p class="text-xs text-blue-800"><strong>Note:</strong> This feature only works in Safari browser on iOS devices.</p>
                    </div>
                </div>
            `;
        
        case 'android':
            return `
                <div class="space-y-4">
                    <div class="flex items-start space-x-3">
                        <span class="flex-shrink-0 w-6 h-6 bg-green-500 text-white text-xs font-bold rounded-full flex items-center justify-center">1</span>
                        <p class="text-sm" style="color: var(--text-current);">Tap the <strong>three dots menu</strong> in your browser</p>
                    </div>
                    <div class="flex items-start space-x-3">
                        <span class="flex-shrink-0 w-6 h-6 bg-green-500 text-white text-xs font-bold rounded-full flex items-center justify-center">2</span>
                        <p class="text-sm" style="color: var(--text-current);">Look for <strong>"Add to Home screen"</strong> or <strong>"Install app"</strong></p>
                    </div>
                    <div class="flex items-start space-x-3">
                        <span class="flex-shrink-0 w-6 h-6 bg-green-500 text-white text-xs font-bold rounded-full flex items-center justify-center">3</span>
                        <p class="text-sm" style="color: var(--text-current);">Tap <strong>"Install"</strong> or <strong>"Add"</strong> to confirm</p>
                    </div>
                    <div class="mt-4 p-3 bg-green-50 rounded-lg">
                        <p class="text-xs text-green-800"><strong>Tip:</strong> Chrome and other modern browsers on Android support PWA installation.</p>
                    </div>
                </div>
            `;
        
        case 'mac':
        case 'windows':
        case 'linux':
        case 'desktop':
            return `
                <div class="space-y-4">
                    <div class="flex items-start space-x-3">
                        <span class="flex-shrink-0 w-6 h-6 bg-purple-500 text-white text-xs font-bold rounded-full flex items-center justify-center">1</span>
                        <p class="text-sm" style="color: var(--text-current);">Look for an <strong>install icon</strong> in your browser's address bar</p>
                    </div>
                    <div class="flex items-start space-x-3">
                        <span class="flex-shrink-0 w-6 h-6 bg-purple-500 text-white text-xs font-bold rounded-full flex items-center justify-center">2</span>
                        <p class="text-sm" style="color: var(--text-current);">Or go to browser menu and look for <strong>"Install Polyglot"</strong></p>
                    </div>
                    <div class="flex items-start space-x-3">
                        <span class="flex-shrink-0 w-6 h-6 bg-purple-500 text-white text-xs font-bold rounded-full flex items-center justify-center">3</span>
                        <p class="text-sm" style="color: var(--text-current);">Click <strong>"Install"</strong> when prompted</p>
                    </div>
                    <div class="mt-4 p-3 bg-purple-50 rounded-lg">
                        <p class="text-xs text-purple-800"><strong>Supported:</strong> Chrome, Edge, and other Chromium-based browsers support PWA installation.</p>
                    </div>
                </div>
            `;
        
        default:
            return `
                <p class="text-sm" style="color: var(--muted-text-current);">
                    Installation steps vary by browser and device. Look for "Install" or "Add to Home Screen" options in your browser menu.
                </p>
            `;
    }
}

function setupInstallPageHandlers(platform, isInstalled) {
    // Back button
    document.getElementById('install-back-button').addEventListener('click', () => {
        showPage('page-main-menu');
    });
    
    // Install button
    const installButton = document.getElementById('install-pwa-button');
    if (installButton) {
        installButton.addEventListener('click', async () => {
            console.log('Install button clicked');
            console.log('window.deferredPrompt:', window.deferredPrompt);
            
            // Try using the deferred prompt if available
            if (window.deferredPrompt) {
                try {
                    installButton.disabled = true;
                    installButton.innerHTML = `
                        <svg class="w-5 h-5 mr-2 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                        </svg>
                        Installing...
                    `;
                    
                    console.log('Showing install prompt...');
                    // Show the install prompt
                    window.deferredPrompt.prompt();
                    
                    // Wait for the user's response
                    const choiceResult = await window.deferredPrompt.userChoice;
                    console.log('User choice:', choiceResult);
                    
                    if (choiceResult.outcome === 'accepted') {
                        console.log('User accepted the install prompt');
                        installButton.innerHTML = `
                            <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                            </svg>
                            Installed!
                        `;
                        
                        // Refresh the page to show installed state
                        setTimeout(() => {
                            initinstall();
                        }, 2000);
                    } else {
                        console.log('User dismissed the install prompt');
                        installButton.disabled = false;
                        installButton.innerHTML = `
                            <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
                            </svg>
                            Install Now
                        `;
                    }
                    
                    // Clear the prompt
                    window.deferredPrompt = null;
                } catch (error) {
                    console.error('Installation failed:', error);
                    installButton.disabled = false;
                    installButton.innerHTML = `
                        <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
                        </svg>
                        Install Now
                    `;
                }
            } else {
                // No install prompt available, show instructions
                console.log('No install prompt available, highlighting instructions');
                installButton.innerHTML = `
                    <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    See Instructions Below
                `;
                
                // Highlight the instructions
                const instructionsSection = document.querySelector('.app-element');
                if (instructionsSection) {
                    instructionsSection.style.border = '2px solid var(--accent-current)';
                    instructionsSection.scrollIntoView({ behavior: 'smooth' });
                    
                    // Remove highlight after a few seconds
                    setTimeout(() => {
                        instructionsSection.style.border = '';
                    }, 3000);
                }
                
                // Reset button after delay
                setTimeout(() => {
                    installButton.innerHTML = `
                        <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
                        </svg>
                        Install Now
                    `;
                }, 3000);
            }
        });
    }
}

// Expose function globally for showPage to access
window.initinstall = initinstall;